import axiosWallet from '../../axios-wallet'

export default {
  namespaced: true,
  state: {
    yip_packages: {},
    chosen_package: null
  },
  mutations: {
    SET_YIP_PACKAGES(state, payload) {
      state.yip_packages = payload
    },
    SET_CHOSEN_PACKAGE(state, payload) {
      state.chosen_package = payload
    }
  },
  actions: {
    fetchPackages({ commit }, data) {
      axiosWallet.get('/guest/aeropay/packages')
        .then(res => {
          commit('SET_YIP_PACKAGES', res.data.yipPackage)
        })
        .catch(error => console.log(error))
    }
  },
  getters: {
    getYipPackages: state => {
      return state.yip_packages
    },
    getChosenPackage: state => {
      return state.chosen_package
    }
  }
}
